import { reloadParentOnly } from '@/utils/routeHelpers';
angular.module('leanlaw').controller('TrustMatterCtrl', ['$scope', '$q', '$state', '$stateParams', 'accountingService', 'userService', 'clientManager', 'matterManager', 'alerts', function ($scope, $q, $state, $stateParams, accountingService, userService, clientManager, matterManager, alerts) {
  $scope.accounts = [];
  $scope.me = {};
  $scope.changeTrustAccount = setClientAccounts;
  activate();
  $scope.save = function () {
    $scope.saving = true;
    getOrCreateAccount().then(done).catch(err => {
      $scope.saving = false;
      alerts.error(err);
    });
  };
  $scope.disconnect = function () {
    if ($scope.matter && $scope.matter.billing.trust) {
      const client = _.find($scope.trust.clients, c => c.client.id == $scope.client.id);
      bootbox.confirm(`This will disconnect the ${$scope.me.terms.matter} ${!client || client.matters.length == 1 ? "and client " : ""}from the trust account. It won't make any changes in QuickBooks.`, result => {
        if (result) {
          $scope.matter.update({
            billing: {
              trust: {}
            }
          }).then(() => {
            if (client && client.matters.length == 1) {
              disconnectClient();
            } else {
              doneAfterDisconnect();
            }
          });
        }
      });
    } else if ($scope.client.billing.trust) {
      bootbox.confirm("This will disconnect the client from the trust account. It won't make any changes in QuickBooks.", result => {
        if (result) {
          disconnectClient();
        }
      });
    }
  };
  function disconnectClient() {
    return $scope.client.update({
      billing: {
        trust: {}
      }
    }).then(doneAfterDisconnect);
  }
  $scope.clientSelected = function () {
    $scope.client.create = !$scope.client.existing;
    if (!$scope.matter) return $q.resolve();
    const id = $scope.client.existing ? $scope.client.existing.id : $scope.client.billing && $scope.client.billing.trust ? $scope.client.billing.trust.account.id : null;
    if (!id) {
      $scope.matter.accounts = [];
      $scope.matter.create = true;
      return $q.resolve();
    }

    // Matter accounts live one level under the client's own trust account, a different parent
    // than the firm's configured root -- fetched only once a client is resolved (nothing to
    // browse until then).
    return accountingService.childAccounts(id).then(accounts => {
      const client = _.find($scope.trust.clients, c => c.account.id == id);
      // Exclude a sibling already claimed by another matter of this client -- compare against
      // the SIBLING's own id (a.id), not its parent id (which is just `id` for every sibling
      // here and so could never exclude one specific account).
      $scope.matter.accounts = _.filter(accounts, a => a.parent && a.parent.id == id && (!client || !client.matters || !_.find(client.matters, m => m.account.id == a.id)));
      $scope.matter.existing = _.find($scope.matter.accounts, m => strip(m.label) == strip($scope.matter.label) || strip(m.name) == strip($scope.matter.name));
      $scope.matter.create = !$scope.matter.existing;
    });
  };
  $scope.matterSelected = function () {
    $scope.matter.create = !$scope.matter.existing;
  };
  $scope.cancel = function () {
    $state.go('^');
  };

  //////////////////

  //// TODO waaaay too much logic in here-- needs to move to service

  let _accountType;
  let _accountSubtype;
  let _accountRoot;
  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      $scope.trustSettings = me.company.settings.trust;
      $scope.trustAccount = $scope.trustSettings.accounts.find(t => t.defaultAccount);
      $scope.loading = true;
      if ($scope.matter || $scope.clientMatter && $scope.clientMatter.matter || $stateParams.matterId || $stateParams.id) {
        initMatter();
      } else if ($scope.client || $scope.clientMatter && $scope.clientMatter.client || $stateParams.clientId) {
        initClient();
      } else {
        throw "Requires client or matter";
      }
    });
  }
  function done() {
    $state.go('^', {}, {
      reload: reloadParentOnly($state.current.name)
    });
  }

  // Disconnect re-reads from the server instead of trusting the local sync below.
  // It is rare and destructive, so what the billing tab shows afterwards matters
  // more than the ancestor states this rebuilds.
  function doneAfterDisconnect() {
    $state.go('^', {}, {
      reload: true
    });
  }

  // The matter carries its own plain copy of the client, and that copy -- not the
  // clientManager instance this dialog edits -- is what the billing tab's trust
  // display reads. Nothing else refreshes it once ancestor states stop re-resolving.
  //
  // Source strictly from the RESOLVED client: update() sends our payload but
  // resolves with what the server returned (via client.load), and it re-targets to
  // the clientMap instance, so neither the request body nor $scope.client is safe
  // to copy from. If the server stored something other than what we asked for, this
  // shows the server's version.
  function syncMatterClientTrust(client) {
    const matterClient = $scope.matter && $scope.matter.client;
    if (!matterClient || !matterClient.billing || !client || !client.billing) return client;
    // Only ever this matter's own client. The paths here all derive one from the
    // other, so a mismatch shouldn't happen -- but writing one client's trust onto
    // another's embedded copy is the failure worth being explicit about.
    if (matterClient.id !== client.id) return client;
    // A copy, never the reference: the resolved client is the session-wide clientMap
    // instance, and the billing tab writes a display label directly onto whichever
    // trust object it renders (matter.billing.ctrl.js). Aliasing would push that
    // write, and anything else done to the matter's copy, into shared client state.
    matterClient.billing.trust = angular.copy(client.billing.trust);
    return client;
  }
  function connect(accounting, item, state) {
    if (accounting.connect) {
      state.message = `To setup trust accounting, the ${item} must be associated with a QuickBooks customer`;
      state.onCancel = function () {
        $scope.message = `The ${item} must be connected to a QuickBooks customer`;
      };
      $state.go('^.connect', state);
    }
    return accounting.connect;
  }
  function initMatter() {
    getMatter().then(matter => matter.getOrConnectAccounting().then(accounting => {
      if (connect(accounting, $scope.me.terms.matter, {
        matterId: matter.id
      })) return;
      $scope.matter = matter;
      userService.me().then(me => {
        setTrustShape(me);
        return $q.all([clientManager.get(matter.client.id), healthCheck(matter.billing.trust), accountingService.trust()]).spread((client, matterHealth, trust) => init(me, client, trust).then(() => {
          applyAccountHealth($scope.matter.billing, matterHealth);
        }));
      }).catch(err => {
        $scope.loading = false;
        alerts.error(err);
      });
    }));
  }
  function initClient() {
    getClient().then(client => client.getOrConnectAccounting().then(accounting => {
      if (connect(accounting, 'client', {
        clientId: client.id
      })) return;
      $scope.client = client;
      if (!client.billing.billClient) {
        throw "Client must be set up as billClient";
      }
      userService.me().then(me => {
        setTrustShape(me);
        return accountingService.trust().then(trust => init(me, client, trust));
      }).catch(err => {
        $scope.loading = false;
        alerts.error(err);
      });
    }));
  }

  // liabilityTracking is the default but some early clients track by subaccounts on the asset side
  function setTrustShape(me) {
    const liabilityTracking = me.company.settings.trust.liabilityTracking !== undefined;
    _accountType = liabilityTracking ? 'OtherCurrentLiability' : 'Bank';
    _accountSubtype = liabilityTracking ? 'TrustAccountsLiabilities' : 'TrustAccounts';
    _accountRoot = liabilityTracking ? me.company.settings.trust.liability.id : me.company.settings.trust.bank.id;
    $scope.liabilityTracking = liabilityTracking;
  }

  // Resolves the stored trust account by id even when it's merely deactivated -- QBO FindById
  // returns an inactive account, only a truly deleted one 404s. Returns null for "confirmed
  // gone"; a non-404 failure (network, 500) propagates as a real load error instead of being
  // mistaken for a deleted account.
  function healthCheck(trust) {
    if (!trust || !trust.account) return $q.resolve(null);
    return accountingService.getAccount(trust.account.id).catch(err => {
      if (err && err.status === 404) return null;
      return $q.reject(err);
    });
  }
  function applyAccountHealth(billingInfo, account) {
    if (billingInfo && billingInfo.trust && !account) {
      billingInfo.trust.error = true;
      return false;
    }
    return true;
  }

  // Every account under the firm's one configured root, active and inactive -- serves both the
  // client name-match dedupe and (via checkValidAccount) the client's own deleted/deactivated
  // detection, since a deactivated sibling still comes back in this list.
  function setClientAccounts() {
    if ($scope.liabilityTracking) {
      if ($scope.client.billing.trust) {
        const existing = $scope.trustSettings.accounts.find(a => a.id === $scope.client.billing.trust.id);
        if (existing) {
          $scope.trustAccount = existing;
        }
      }
      _accountRoot = $scope.trustAccount.liability.id;
    }
    return accountingService.childAccounts(_accountRoot).then(accounts => {
      $scope.accounts = accounts;
      $scope.client.accounts = accounts;
    });
  }
  function init(me, client, trust) {
    $scope.loading = false;
    $scope.me = me;
    $scope.client = client;
    $scope.trust = trust;
    return setClientAccounts().then(() => {
      $scope.client.existing = $scope.accounts.find(c => strip(c.label) == strip($scope.client.label) || strip(c.name) == strip($scope.client.name));
      $scope.client.create = !$scope.client.existing;
      return $q.when($scope.clientSelected()).then(() => {
        checkValidAccount($scope.client.billing);
      });
    });
  }
  function getMatter() {
    if ($scope.matter && $scope.matter.id) {
      return $q.resolve($scope.matter);
    }
    if ($scope.clientMatter && $scope.clientMatter.matter) {
      return $q.resolve($scope.clientMatter.matter);
    }
    return matterManager.get($stateParams.matterId || $stateParams.id);
  }
  function getClient() {
    if ($scope.client && $scope.client.id) {
      return $q.resolve($scope.client);
    }
    if ($scope.clientMatter && $scope.clientMatter.client) {
      return $q.resolve($scope.clientMatter.client);
    }
    return clientManager.get($stateParams.clientId || $stateParams.id);
  }
  function strip(str) {
    return str ? str.replace(/\W+/g, '').toLowerCase() : "";
  }
  function checkValidAccount(billingInfo) {
    if (billingInfo && billingInfo.trust) {
      if (!_.find($scope.accounts, a => a.id == billingInfo.trust.account.id)) {
        billingInfo.trust.error = true;
        return false;
      }
    }
    return true;
  }
  function getOrCreateAccount() {
    return getOrCreateClientAccount().then(client => {
      if (!$scope.matter || client.billing.billClient) {
        return $q.resolve();
      }
      if ($scope.matter.billing && $scope.matter.billing.trust && !$scope.matter.billing.trust.error) {
        return $q.when($scope.matter);
      }
      if ($scope.matter.existing) {
        return updateMatter($scope.matter.existing);
      }
      return accountingService.createAccount({
        name: $scope.matter.label,
        type: _accountType,
        subtype: _accountSubtype,
        parent: {
          id: client.billing.trust.account.id
        },
        balance: $scope.matter.balance
      }).then(account => updateMatter(account));
    });
  }
  function updateMatter(account) {
    return $scope.matter.update({
      billing: {
        trust: {
          id: $scope.trustAccount.id,
          label: $scope.trustAccount.label,
          account: {
            id: account.id,
            name: account.name
          }
        }
      }
    });
  }
  function getOrCreateClientAccount() {
    if ($scope.client.billing && $scope.client.billing.trust && !$scope.client.billing.trust.error) {
      return $q.when($scope.client);
    }
    if ($scope.client.existing) {
      return updateClient($scope.client.existing);
    }
    const liabilityTracking = $scope.me.company.settings.trust.liabilityTracking !== undefined;
    return accountingService.createAccount({
      name: $scope.client.label,
      type: _accountType,
      subtype: _accountSubtype,
      parent: {
        id: _accountRoot
      },
      balance: $scope.client.balance
    }).then(account => updateClient(account));
  }
  function updateClient(account) {
    return $scope.client.update({
      billing: {
        trust: {
          id: $scope.trustAccount.id,
          label: $scope.trustAccount.label,
          account: {
            id: account.id,
            name: account.name
          }
        }
      }
    }).then(syncMatterClientTrust);
  }
}]);